import { useEffect } from "react";
import { useLocale } from "@genius-tracker/i18n/react";
import { setModuleRefusalListener } from "../lib/moduleRefusalNotice.js";
import { useToast } from "./Toast.js";

/** One visible explanation for module enforcement, regardless of the caller. */
export function ModuleRefusalToastBridge(): null {
  const { push } = useToast();
  const { t } = useLocale();
  useEffect(() => {
    setModuleRefusalListener((code, requestId) => {
      const kind = code === "module_not_booked" ? "not_booked" : "read_only";
      push({
        tone: "warn",
        title: t(`errors.module.${kind}.title`),
        message: t(`errors.module.${kind}.body`),
        requestId,
      });
    });
    return () => setModuleRefusalListener(null);
  }, [push, t]);
  return null;
}
